<template>

    <div class="form-group col-12">
        <div class="col-12">
            <div class="row">
                <div class="col-lg-2 col-md-12">
                    <button class="btn btn-secondary"
                            @click.stop="saveSettings"
                            :disabled="saving">
                        <i class="fas fa-save"></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                </div>
                <div class="col-lg-10 col-md-12">
                    <multi-select :loadByParentSort="true"
                                  :parentSort="directorateSort"
                                  :fieldName="$t('organizationalModel.eventForm')"
                                  v-model="settings.directoratesIds"
                                  :isCity="false"
                                  :readonly="false">
                    </multi-select>
                </div>

            </div>
        </div>
    </div>


</template>

<script>
    import { EventsGridSettingsModel } from '../../../models/models';
    import { Culture, NomenclatureParentBySort } from '../../../models/enums';
    import MultiSelect from '../../../components/dropdown/MultiSelect';
    import personalizationService from '../../../services/personalization.service'

    export default {
        components: {
            MultiSelect
        },
        props: {
            settings: {
                type: EventsGridSettingsModel
            }
        },
        data() {
            return {
                name: 'EventsGridControls',
                loaded: false,
                saving: false,
                directorateSort: NomenclatureParentBySort.Directorate
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            clearSource() {
                if (Array.isArray(this.settings.directoratesIds)) {
                    while (this.settings.directoratesIds.length > 0) {
                        this.settings.directoratesIds.pop();
                    }
                }
            },
            loadSettings() {
                this.clearSource();
                this.loaded = false;

                personalizationService
                    .loadEventsListUserSettings()
                    .then(response => {
                        if (response.data.settings && Array.isArray(response.data.settings.directoratesIds)
                                && response.data.settings.directoratesIds.length > 0) {
                            response.data.settings.directoratesIds.forEach(id => {
                                this.settings.directoratesIds.push(id)
                            })
                        }

                        this.loaded = true;
                        this.$emit('reloaded');
                    })
                    .catch(error => {
                        this.loaded = true;
                        this.settings = new EventsGridSettingsModel();
                        this.$emit('reloaded');

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            saveSettings() {
                this.loaded = false;
                this.saving = true;

                personalizationService
                    .saveEventsListUserSettings(this.settings)
                    .then(response => {
                        this.loaded = true;
                        this.saving = false;
                        this.$emit('reloaded');

                        this.$vs.notify({
                            title: this.$t('buttons.saveGridOptions.btnText'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    })
                    .catch(error => {
                        this.loaded = true;
                        this.saving = false;
                        this.$emit('reloaded');

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
        },
        mounted() {
            this.loadSettings();
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            }
        }

    }
</script>

<style scoped>
    .invalid-slot {
        background: red !important;
        cursor: no-drop;
    }

    /* Hide toolbar, navigation and footer during export */
    .k-pdf-export .k-scheduler-toolbar,
    .k-pdf-export .k-scheduler-navigation .k-nav-today,
    .k-pdf-export .k-scheduler-navigation .k-nav-prev,
    .k-pdf-export .k-scheduler-navigation .k-nav-next,
    .k-pdf-export .k-scheduler-footer {
        display: none;
    }
</style>
